import Env from '../base/env';
import Component from 'gia/Component';
import CSC from "canvas-scroll-clip";
import gsap from 'gsap'
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger,SplitText)
import { InteractiveModuleRevealText } from '../fx/Common'


export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.options = JSON.parse(this.element.getAttribute('data-options'))
    //! DOM
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.anchorInTheFlow = this.DOM.view.parentElement.querySelector('.interactive-sequence-anchor')
    //
    this.animTexts = []
    //! VARS
    this.VARS = {}
    this.VARS.PADDING_CIRCLE = 200
    this.VARS.FEATURES_SIZE = 15
    this.VARS.NEW_SLIDE = 0
    this.VARS.CURRENT_SLIDE = -1
    this.VARS.SLIDE_ACTIVE = false
    this.VARS.SIZE_SCROLL = 2000
    this.VARS.TOTAL_SEQ = this.options.totalSequence - 1
    this.VARS.PATH_SEQ = this.options.sequencePath
    this.TOTAL_SLIDES = this.ref.step.length - 1
    this.VARS.IS_ANIMATING = false

    this.makeSequence()
    this.makeSticky()
    this.prepareTexts()
    this.events()
  }

  animateText()
  {


    if(this.VARS.SLIDE_ACTIVE == true && this.VARS.NEW_SLIDE != this.VARS.CURRENT_SLIDE && this.VARS.IS_ANIMATING == false) {
      const DOM = this.animTexts[this.VARS.NEW_SLIDE].DOM
      const FX = this.animTexts[this.VARS.NEW_SLIDE].FX
      this.VARS.IS_ANIMATING = true
      InteractiveModuleRevealText(DOM,FX,()=>{
        this.VARS.IS_ANIMATING = false
      })
    }
  }

  events()
  {
    for (const [i, anchor] of this.ref.anchor.entries()) {
      anchor.addEventListener('click',()=>{
        this.moveScroll(i)
      })
    }
  }

  go()
  {
    this.reset()
    if(this.VARS.NEW_SLIDE >= 0 && this.VARS.SLIDE_ACTIVE == true) {
      this.ref.step[this.VARS.NEW_SLIDE].classList.add('is-active')
      this.ref.anchor[this.VARS.NEW_SLIDE].classList.add('is-active')
      this.ref.progress[this.VARS.NEW_SLIDE].classList.add('is-active')
      this.ref.reminder[this.VARS.NEW_SLIDE].classList.add('is-active')
    }

    this.animateText()
    this.VARS.CURRENT_SLIDE = this.VARS.NEW_SLIDE


  }

  listener(st)
  {

    const limit =  1 / this.ref.step.length
    for (const [i, item] of this.ref.step.entries()) {
      const startPoint = (item.getAttribute('data-start') * 1) / 100
      const endPoint = (item.getAttribute('data-end') * 1) / 100
      if(st.progress >= startPoint && st.progress < endPoint) {
        this.VARS.NEW_SLIDE = i
        this.VARS.SLIDE_ACTIVE = true
        break;
      } else {
        this.VARS.SLIDE_ACTIVE = false
      }
    }
  }

  makeSequence()
  {
    this.sequence = new CSC(this.ref.canvasContainer[0], {
      framePath: config.pathWpContent+"/scroll-sequence/"+this.VARS.PATH_SEQ+"/0_0000.png",
      frameCount: this.VARS.TOTAL_SEQ,
      scrollArea: this.VARS.SIZE_SCROLL
    })
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      end:`+=${this.VARS.SIZE_SCROLL / 1.5}px`,
      pin:true,
      pinSpacing:true,
      invalidateOnRefresh: true,
      onUpdate:(e)=>{
        this.listener(e)
        this.go()
        gsap.set(
          this.ref.progression,
          {
            transformOrigin:'left top',
            scaleX:e.progress
          }
        )
      },
      onEnter:()=>{
        this.DOM.view.classList.remove('is-disabled')
      },
      onEnterBack:()=>{
        this.DOM.view.classList.remove('is-disabled')
      },
      onLeaveBack:()=>{
        this.DOM.view.classList.add('is-disabled')
        this.resetWhenOutside()
      },
      onLeave:()=>{
        this.DOM.view.classList.add('is-disabled')
        this.resetWhenOutside()
      }
    })
  }

  moveScroll(index)
  {
    const posY = this.DOM.anchorInTheFlow.getBoundingClientRect().top + Env.framework.toolbox.scrollPosition().scrollY
    const ratioMove = (this.VARS.SIZE_SCROLL / 1.5) / (this.ref.anchor.length - 1)
    const offset = (typeof this.ref.anchor[index].getAttribute('data-offset') != 'undefined')?this.ref.anchor[index].getAttribute('data-offset')*1:0
    gsap.to(window, {
      scrollTo: ((ratioMove*index)+posY)+offset,
      duration: 3,
      ease:'cubic.out'
    });
  }

  prepareTexts()
  {
    for (const [i, step] of this.ref.step.entries()) {
      const DOM = {}
      const FX = {}
      DOM.item = step
      DOM.title = DOM.item.querySelector('.title')
      DOM.desc = DOM.item.querySelector('.desc')
      DOM.bar = DOM.item.querySelector('.bar')
      FX.title = new SplitText(DOM.title,{ type:'chars' })
      FX.desc = new SplitText(DOM.desc,{ type:'lines' })
      this.animTexts.push({
        DOM:DOM,
        FX:FX
      })
    }

  }

  reset() {
    for (const [i, step] of this.ref.step.entries()) {
      step.classList.remove('is-active')
      this.ref.anchor[i].classList.remove('is-active')
      this.ref.progress[i].classList.remove('is-active')
      this.ref.reminder[i].classList.remove('is-active')
      step.classList.remove('is-prev')
      if(i < this.VARS.NEW_SLIDE) {
        step.classList.add('is-prev')
      }
    }
  }

  resetWhenOutside()
  {
    this.VARS.CURRENT_SLIDE = -1
    this.reset()
  }

  unmount()
  {
    this.sticky.kill()
  }
}
